import styled from 'styled-components';
import { COMMON_MOBILE_BREAKPOINT } from '@elfsight/lib-utils';
import { Typography } from '@elfsight/widget-ui';
import { useWidgetRect } from '@elfsight/widget-utils';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import type { WheelRewardType } from '../wheel';
import { InitContent } from './init-content';
import { RewardContent } from './reward-content';

interface ContentProps {
  closePopup: () => void;
  spin: () => void;
  winningReward?: WheelRewardType;
  className?: string;
}

export const Content = ({
  className,
  closePopup,
  spin,
  winningReward
}: ContentProps) => {
  const widgetRect = useWidgetRect();
  const isMobile =
    !!widgetRect?.width && widgetRect?.width < COMMON_MOBILE_BREAKPOINT;

  return (
    <SwitchTransition>
      <CSSTransition
        key={winningReward ? 'winningReward' : 'initial'}
        timeout={500}
        classNames="fade"
        unmountOnExit
      >
        {winningReward ? (
          <RewardContent
            className={className}
            closePopup={closePopup}
            isMobile={isMobile}
            winningReward={winningReward}
            spin={spin}
          />
        ) : (
          <InitContent
            className={className}
            closePopup={closePopup}
            spin={spin}
            isMobile={isMobile}
          />
        )}
      </CSSTransition>
    </SwitchTransition>
  );
};

export const Disclaimer = styled(Typography)<{
  _color: string;
}>`
  color: ${({ _color }) => _color};
  opacity: 0.5;
  font-size: 13px;
  margin-top: 24px;

  a {
    text-decoration: underline;
  }
`;

export const Decline = styled(Typography)<{
  _color: string;
  _fontSize: number;
}>`
  cursor: pointer;
  text-decoration: underline;
  font-size: ${({ _fontSize }) => _fontSize + 'px'};
  text-align: center;
  color: ${({ _color }) => _color};
  opacity: 0.5;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 0.7;
  }
`;

export const ContentContainer = styled.div`
  max-width: 408px;
  z-index: 10;
  gap: 24px;
  display: flex;
  flex-direction: column;

  &.fade-enter {
    opacity: 0;
    transform: translateY(15px);
  }

  &.fade-enter-active {
    opacity: 1;
    transform: translateY(0);
    transition:
      opacity 0.5s,
      transform 0.5s;
  }

  &.fade-exit {
    opacity: 1;
    transform: translateY(0);
  }

  &.fade-exit-active {
    opacity: 0;
    transform: translateY(15px);
    transition:
      opacity 0.5s,
      transform 0.5s;
  }
`;
